var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"receipt-88"},[_c('div',{staticStyle:{"width":"88mm"},domProps:{"innerHTML":_vm._s(_vm.receiptHtml)}})])}
var staticRenderFns = []

export { render, staticRenderFns }